// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "06ba4f7bdde12a1d1cd3" + ".chunk.js";
};